import './AboutValues.scss';

const values = [
  {
    title: 'Menos complicação',
    description: 'Começamos pelo simples, com o que faz diferença.',
    imageUrl: '/images/aboutpage/about-rocket.svg',
  },
  {
    title: 'Ferramentas com propósito',
    description: 'Não oferecemos soluções genéricas. Tudo tem que servir ao seu negócio.',
    imageUrl: '/images/aboutpage/about-plant.svg',
  },
  {
    title: 'Digital sem stress',
    description: 'Ajudamos a digitalizar com leveza, no seu ritmo.',
    imageUrl: '/images/aboutpage/about-digital.svg',
  },
  {
    title: 'Foco no cliente',
    description: 'Acreditamos que melhorar a experiência do seu cliente é o que move resultados reais.',
    imageUrl: '/images/aboutpage/about-customer.svg',
  },
];

const AboutValues = () => {
  return (
    <section className="about-values section">
      <div className="wrapper wrapper--large">
        <h2 className="wrapper__title centered">Os nossos valores</h2>

        <div className="row col-4">
          {values.map((value, index) => (
            <div key={index} className="col card">
              <img className="card__icon" alt="" src={value.imageUrl} />
              <h3 className="card__title h4">{value.title}</h3>
              <p className="card__description centered">{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutValues;